import { gql } from '@apollo/client'

export const CHART1_ON_CASE_STATE_QUERY = gql`
  query m2CasesOnCaseStateTotalCount(
    $groupBy: M2CaseOnCaseStateGroupBy
    $filter: M2CaseOnCaseStateStatisticFilter
  ) {
    m2CasesOnCaseStateTotalCount(groupBy: $groupBy, filter: $filter) {
      series {
        color
        title
        casesAverage
        serie {
          name
          date
          count
        }
      }
    }
  }
`
